import styled from 'styled-components';
import { Select as AntDesignSelect } from 'antd';

export const Select = styled(AntDesignSelect)``;
